/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import DefaultResolver from 'flarum/common/resolvers/DefaultResolver';
import { slug } from '../../common';

/**
 * Sends gamification routes to the index while the master switch is off.
 *
 * Redirecting in `onmatch` rather than the page's `oninit` means the page is never built:
 * `m.route.set()` here supersedes the pending match, so no `oninit` requests fire and no
 * `view()` renders against state that was never set up. The router forces `replace` for a
 * redirect issued mid-match, so the dead URL leaves no history entry.
 */
export default class GamificationResolver extends DefaultResolver {
  /**
   * The redirect branch returns nothing, which Mithril accepts; declared as the parent's
   * type so `Extend.Routes` still takes this class where it expects a DefaultResolver.
   *
   * @returns {ReturnType<DefaultResolver['onmatch']>}
   */
  onmatch(args, requestedPath, route) {
    if (!app.forum.attribute(`${slug}.gamification.enabled`)) {
      m.route.set(app.route('index'), null, {
        replace: true
      });
      return;
    }
    return super.onmatch(args, requestedPath, route);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/resolvers/GamificationResolver', GamificationResolver);